// extracted by mini-css-extract-plugin
export default {"threeCols":"threeColumns_threeCols__YFCOq","col":"threeColumns_col__FoL9B","img":"threeColumns_img__pOE1d","hr":"threeColumns_hr__UOfaR"};